import React, { useEffect, useState } from "react";
import { API_BASE } from "../config";
import { apiFetch } from "../utilities/apiFetch";
import { oficialDeBd } from "../utilities/conciliacionBancaria";

// Seguimiento de casos -> "Pagos reasignados" (solo Administrador, solo de conocimiento): el plantel paso el pago de
// la orden de un alumno a la de otro (Historial o caso "Se tecleó el folio de otro alumno"). No necesita autorizacion.

const dinero = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fechaHora = (ts) => (ts ? `${String(ts).substring(8, 10)}/${String(ts).substring(5, 7)}/${String(ts).substring(0, 4)} ${String(ts).substring(11, 16)}` : "");
const estiloTh = { textAlign: "left", padding: "6px 8px", borderBottom: "2px solid #ddd", fontSize: "0.8rem", whiteSpace: "nowrap" };
const estiloTd = { padding: "6px 8px", borderBottom: "1px solid #eee", fontSize: "0.85rem", verticalAlign: "top" };
export const DIAS_AVISO_REASIGNACIONES = 7;

const VistaReasignaciones = ({ nombresPlanteles = {} }) => {
  const [lista, setLista] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await apiFetch(`${API_BASE}/wMultipagosReasignaciones.php?dias=90`);
        const json = await res.json();
        if (!json.success) { setError(json.message || "No se pudieron consultar los pagos reasignados."); setLista([]); return; }
        setLista(Array.isArray(json.data) ? json.data : []);
      } catch (e) {
        setError("No hubo respuesta del servidor al consultar los pagos reasignados.");
        setLista([]);
      }
    };
    cargar();
  }, []);

  if (lista === null) return null;
  const hace = Date.now() - DIAS_AVISO_REASIGNACIONES * 24 * 3600 * 1000;
  const recientes = lista.filter((r) => new Date(String(r.fecha).substring(0, 19).replace(" ", "T")).getTime() >= hace).length;

  return (
    <div style={{ margin: "0 0 16px 0" }}>
      <h4 style={{ margin: "0 0 4px 0", color: "#003b5c" }}>Pagos reasignados por los planteles (últimos 90 días)</h4>
      <p style={{ color: "#666", fontSize: "0.85rem", margin: "0 0 6px 0" }}>
        Solo de conocimiento: el plantel pasó el pago de la orden de un alumno a la de otro, con su justificación. La primera orden regresó a PENDIENTE.
        {lista.length > 0 && <> <b>{recientes}</b> en los últimos {DIAS_AVISO_REASIGNACIONES} días.</>}
      </p>
      {error && <div style={{ padding: "8px", backgroundColor: "#fdecea", border: "1px solid #f5c6cb", color: "#7a1c1c", borderRadius: "4px", fontSize: "0.85rem" }}>{error}</div>}
      {!error && !lista.length && <p style={{ fontSize: "0.85rem", color: "#555" }}>Ningún plantel ha reasignado pagos.</p>}
      {lista.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead><tr>{["Fecha", "Plantel", "Pago", "Estaba en", "Pasó a", "Quién", "Justificación"].map((t) => <th key={t} style={estiloTh}>{t}</th>)}</tr></thead>
            <tbody>
              {lista.map((r) => {
                const oficial = oficialDeBd(r.id_plantel);
                return (
                  <tr key={r.id}>
                    <td style={estiloTd}>{fechaHora(r.fecha)}{r.id_caso ? <div style={{ fontSize: "0.75rem", color: "#666" }}>caso {r.id_caso}</div> : null}</td>
                    <td style={estiloTd}>{oficial} {nombresPlanteles[oficial] || ""}</td>
                    <td style={estiloTd}>{dinero(r.importe)}{r.dato ? <div style={{ fontSize: "0.75rem", color: "#666" }}>{r.dato}</div> : null}</td>
                    <td style={estiloTd}>Orden {r.orden_origen}<div style={{ fontSize: "0.75rem", color: "#666" }}>{r.matricula_origen}</div></td>
                    <td style={estiloTd}>Orden {r.orden_destino}{r.folio_destino ? ` · folio ${r.folio_destino}` : ""}<div style={{ fontSize: "0.75rem", color: "#666" }}>{r.matricula_destino}</div></td>
                    <td style={estiloTd}>{r.usuario}</td>
                    <td style={estiloTd}>{r.motivo}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VistaReasignaciones;
